const container = document.querySelector('[data-blocks-container]');
const block1 = container.querySelector('[data-block-index="1"]');
const block3 = container.querySelector('[data-block-index="3"]');
const circle = document.querySelector('[data-circle]');

const mm = gsap.matchMedia();


mm.add('(min-width: 1024px)', () => {

    gsap.timeline({
        scrollTrigger: {
            trigger: container,
            start: 'top bottom',
            end: () => 'center ' + (window.innerHeight * 0.5 + 200),
            scrub: 1
        }
    })

        .from(block1, {
            y: -40,
            ease: 'none'
        }, 0)
        .from(block3, {
            y: 40,
            ease: 'none'
        }, 0)
        .fromTo(circle, {
            y: 80,
            ease: 'none'
        },
            {
                y: -20,
                ease: 'none'
            }
            , '<');

});